<!--
BEDROCK Core
Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
-->


<template>

    <div class="sdev-page">

        <!-- Header -->
        <PageHeader v-if="resolvedHeader" :title="resolvedHeader.title" :subtitle="resolvedHeader.subtitle"
            :breadcrumb="resolvedHeader.breadcrumb" :actions="resolvedHeader.actions" :tags="resolvedHeader.tags" />

        <!-- Main Content -->
        <PageContent>

            <!-- Tabs -->
            <PageTabs v-if="tabs?.length" :tabs="tabs" :activeTab="currentTab"
                @update:activeTab="currentTab = $event" />

            <!-- Tab Content -->
            <slot :name="`tab-${currentTab}`" :rows="[]" :loading="false" :select="() => { }">

            </slot>

        </PageContent>

        <!-- Footer -->
        <PageFooter v-if="$slots[`footer-${currentTab}`]">
            <slot :name="`footer-${currentTab}`" />
        </PageFooter>

    </div>

</template>

<script setup>

import { computed } from "vue"
import { useRoute } from "vue-router"
import { useMetaActions } from "@/domain/meta/actionRegistry"

const props = defineProps({
    header: Object,
    tabs: Array,
    activeTab: String
})

const emit = defineEmits(["update:activeTab"])

const route = useRoute()
const { handle } = useMetaActions()

/*
────────────────────────────────────────
Resolve Header
────────────────────────────────────────
Props override route meta
*/

const resolvedHeader = computed(() => {

    const meta = route.meta ?? {}

    const base = {
        title: meta.title,
        subtitle: meta.subtitle,
        breadcrumb: [
            { label: "Core", to: "/" },
            { label: meta.title, to: route.fullPath }
        ],
        tags: meta.tags ?? {},
        actions: (meta.actions ?? []).map(a => ({
            ...a,
            onClick: () => handle(a, route)
        }))
    }

    return {
        ...base,
        ...(props.header ?? {})
    }

})

/*
────────────────────────────────────────
Tab Model
────────────────────────────────────────
*/
const currentTab = computed({
    get: () => props.activeTab,
    set: (val) => emit("update:activeTab", val)
})

</script>